<template>
  <div class="baoxiu_list">
    <section>
      <li class="baoxiu_item" v-for="(item, ind) in list" :key="ind" >

        <p class="baoxiu_flex">
                <span>
                    姓名：{{item.name}}
                </span>
          <span :class="getColor(item.shzt)">
              {{item.shzt}}
          </span>
        </p>

        <p class="baoxiu_flex">
          <span>
                   手机号：{{item.mobNo}}
                </span>
        </p>
        <p class="baoxiu_flex">
                <span>
                    身份证号：{{item.idNumber}}
                </span>

        </p>

        <p class="baoxiu_flex">
                <span>
                    申请日期：{{item.createdTime}}
                </span>

        </p>

      </li>
      <p class="no_data" v-if="!list.length">
        暂无业务记录
      </p>
    </section>
    <footer>
      <button class="btn_bx" @click="goBx" type="primary">申 请 更 名</button>
    </footer>

  </div>
</template>

<script>
  import { getYwjl } from '@/api'
  import {validSlsx} from "@/utils";
  export default {
    data() {
      return {
        list: [],
        value: '',
        taskTypeOptioon:[
          {value:'报修',label:'报修'},
          {value:'投诉',label:'投诉'},
          {value:'建议',label:'建议'},
          {value:'测温',label:'测温'},
        ],
        form:{
          taskType:''
        },
        rules:{}
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      getList(){
        let params = {
          customerId: this.$route.query.userId,
          type: 'gh'
        }
        getYwjl(params).then(res=> {
          this.list = res.data.gmghList
        })
      },
      jjyy(item) {
        if(item.shzt=='未通过') {
          this.$router.push({
            path: '/jjyy',
            query: {
              id: item.id
            }
          })
        }
      },
      goPj(ordersn) {
        this.$router.push({
          path: '/pj',
          query: {
            ordersn: ordersn
          }
        })
      },
      getColor(type) {
        let className = 'text_green'
        if(type=='审核中') {
          className = 'text_orange'
        } else if(type=='未通过') {
          className = 'text_red'
        }

        return className
      },
      goBx() {
        if(validSlsx('更名')){
          this.$router.push({
            path: '/changeInfo',
            query: this.$route.query
          })
        }
      }
    }
  }
</script>

<style scoped>

  .baoxiu_list{
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
    width:100%;
    height:90%;
  }
  .demo-ruleForm{
    margin-top: 5px;
    margin-left: 10px;
  }
  .btn_bx{
    width: 94%;
    margin-left: 3%;
    /*margin-top: 3rem;*/
    font-size: 1rem;
    height: 2.5rem;
    background: #47c34d;
    border-radius: 3px;
  }
  .text_green{
    color: #47c34d;
  }
  .text_blue{
    color: #1E88C7;
  }
  .text_red{
    color: red;
  }
  .text_orange{
    color:orange;
  }
  header,footer{
    height:40px;
    line-height: 40px;

    /*text-align:center;*/
  }
  header{
    margin-bottom: 5px;
    background-color:#fff;

  }
  section{
    -webkit-box-flex:1;
    -webkit-flex:1;
    -ms-flex:1;
    flex:1;
    width:100%;
    overflow:auto;/* winphone8和android4+ */
    -webkit-overflow-scrolling: touch; /* ios5+ */
  }

  .baoxiu_item{
    border-bottom: 5px solid #f1f1f1;
    padding: 3%;
    line-height: 25px;
    background: #fff;
  }
  .baoxiu_flex{
    display: flex;
    justify-content: space-between;
  }
  .goPj{
    color: #1890ff;
  }

</style>



// WEBPACK FOOTER //
// src/view/ywbl/gm/gmList.vue